import { ENDPOINTS } from "../utils/api/endpoints";
import { triggerBlobDownload } from "utils/Common/fileDownload";

export const exportChangeOrdersCSV = async (
  projectId: string,
  status?: string,
): Promise<{ success: boolean; message: string }> => {
  try {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    const base = process.env.REACT_APP_API_BASE_URL ?? "";

    const endpoint = ENDPOINTS.ADMIN.CHANGE_ORDERS_EXPORT(projectId, status);
    const res = await fetch(`${base}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-role": role ?? "",
      },
    });

    if (!res.ok) {
      return {
        success: false,
        message: `Failed to export. Status: ${res.status}`,
      };
    }

    const blob = await res.blob();
    const filename = `change-orders-${projectId}-${new Date().toISOString().split("T")[0]}.csv`;
    triggerBlobDownload(blob, filename);

    return {
      success: true,
      message: "Change orders exported successfully.",
    };
  } catch (error) {
    return {
      success: false,
      message: "Error exporting change orders.",
    };
  }
};
